module.exports = __webpack_public_path__ + "static/media/Ubuntu-LightItalic.b242f3fd.ttf";